/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowPathIcon } from "@heroicons/react/24/solid";

export default function SupportResult({ type }) {
  const params     = new URLSearchParams(window.location.search);
  const paymentId       = params.get("paymentId");
  const [state, setState] = useState(
    type === "success" ? "pending" : type
  );

  useEffect(() => {
    if (!paymentId) return;
    const int = setInterval(async () => {
      const { result } = await fetch(`/api/paymentStatus/${paymentId}`)
                                 .then(r => r.json());
      if (result === "Succeeded") { setState("success"); clearInterval(int); }
      if (result === "Failed")    { setState("error");   clearInterval(int); }
      if (result === "Canceled")    { setState("cancel");   clearInterval(int); }
    }, 4000);
    return () => clearInterval(int);
  }, [paymentId]);


  return (
    <main className="mx-auto max-w-lg px-4 py-24 text-center">
      {state === "success" && (
        <>
          <h1 className="mb-4 text-3xl font-bold text-emerald-600">Köszönjük a támogatást!</h1>
          <p className="mb-8">E-mailben visszaigazoljuk az előfizetés részleteit.</p>
          <Link to="/" className="text-primary underline">Vissza a főoldalra</Link>
        </>
      )}

      {state === "pending" && (
        <>
          <ArrowPathIcon className="mx-auto mb-6 h-12 w-12 animate-spin text-blue-600" />
          <p>Fizetés feldolgozása…</p>
        </>
      )}

      {state === "error" && (
        <>
          <h1 className="mb-4 text-3xl font-bold text-rose-600">A fizetés nem sikerült</h1>
          <p className="mb-8">Próbáld újra, vagy írj nekünk bármilyen kérdés esetén.</p>
          <Link to="/support" className="text-primary underline">Vissza a csomagokhoz</Link>
        </>
      )}

      {state === "cancel" && (
        <>
          <h1 className="mb-4 text-3xl font-bold text-gray-700">
            Előfizetés visszavonva
          </h1>

          <Link
            to="/support"
            className="inline-block rounded-md bg-blue-600 px-6 py-3 font-semibold text-white transition hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-400"
          >
            Vissza a támogatásokhoz
          </Link>
        </>
      )}
    </main>
  );
}
